export enum NorthCapitalRequestStatus {
    Pending = 'Pending',
    Fail = 'Fail',
    Success = 'Success',
}
